module.exports = __webpack_public_path__ + "static/media/Wonder women 3.b0794414.jpg";